import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getSummarizeSpokenText = (params) => {
	var url = ApiRouters.SUMMARIZESPOKENTEXT;
	return api.get(url, { params });
};

export const getSummarizeSpokenTextDetail = (id, params) => {
	var url = `${ApiRouters.SUMMARIZESPOKENTEXT}/${id}`;
	return api.get(url, { params });
};

export const createQuesSummarizeSpokenText = (body) => {
	var url = ApiRouters.SUMMARIZESPOKENTEXT;
	return api.post(url, body);
};

export const updateSummarizeSpokenTextDetail = (body) => {
	const { id, model } = body
	var url = `${ApiRouters.SUMMARIZESPOKENTEXT}/${id}`;
	return api.put(url, model);
};

export const deleteSummarizeSpokenText = (id) => {
	var url = `${ApiRouters.SUMMARIZESPOKENTEXT}/${id}`;
	return api.delete(url);
};
